import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { Alert } from 'us-react-components/dist/Alert/Alert';
import { getAdminUrl } from 'us-react-components/dist/utils/string';
import { ParentService, UserService } from 'us-web-services';

import { Link, NavLink } from '..';
import { Button, ButtonSize, ButtonType } from '../Button';
import { Storage } from '../../constants';
import { useDependencies } from '../../dependencies';
import Notifications from './components/Notifications';
import Profile from './components/Profile';
import MainLinks from './components/MainLinks';
import Messages from './components/Messages';
import MobileMenu from './components/MobileMenu';

const LOGO_URL = 'https://assets.urbansitter.com/static/img/logos/urbansitter_logo_color.svg';

export const MainHeader = (): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { stores } = useDependencies();

  const getName = (): string => `${stores.sitter.sitter?.firstName} ${stores.sitter.sitter?.lastName}`;

  const isMasquerading = (): boolean => localStorage.getItem(Storage.ORIGINAL_USER_ID) !== null;

  const unMasquerade = async (): Promise<void> => {
    const adminId = Number(localStorage.getItem(Storage.ORIGINAL_USER_ID));
    const adminUser = (await UserService.get(adminId)).data.data;
    const adminParent = (await ParentService.get(adminId)).data.data;

    localStorage.setItem(Storage.US_USER_OBJECT, JSON.stringify(adminUser));
    localStorage.setItem(Storage.US_PARENT_OBJECT, JSON.stringify(adminParent));
    localStorage.removeItem(Storage.ORIGINAL_USER_ID);
    localStorage.removeItem(Storage.US_SITTER_OBJECT);
    localStorage.removeItem(Storage.US_USER_TESTS_OBJECT);

    window.location.href = getAdminUrl();
  };

  return (
    <>
      <header className='py-3.5 shadow'>
        <div className='container flex relative'>
          <nav className='shrink-0 mt-0 md:flex md:w-9/12'>
            <NavLink to='/caregiver/dashboard' end>
              <img
                src={LOGO_URL}
                alt={t('components.header.logo.alt')}
                className='hidden lg:inline-block mr-4 w-auto'
                id='urbansitter-logo-desktop'
              />
              <img
                src={LOGO_URL}
                alt={t('components.header.logo.alt')}
                className='inline-block lg:hidden -ml-2 mt-2 flex w-8/12'
                id='urbansitter-logo-mobile'
              />
            </NavLink>
            <div className='md:flex hidden w-9/12 justify-center'><MainLinks /></div>
          </nav>
          <div className='flex flex-row items-center justify-end text-right absolute right-1'>
            <Messages />
            <Notifications />
            <div className='hidden md:inline-block'>
              <Profile />
            </div>
            <div className='md:hidden'>
              <MobileMenu />
            </div>
          </div>
        </div>
      </header>
      {isMasquerading() && (
        <div className='w-full mx-auto mt-[1px]'>
          <Alert color='warning' isOpen={isMasquerading()}>
            Masquerading as <Link className='font-bold text-sapphire' to={`/sitter/${stores.sitter.sitter?.id}`}>{getName()}</Link>
            <Button buttonSize={ButtonSize.small} buttonType={ButtonType.primary} className='ml-5 !py-1 !px-4' onClick={unMasquerade}>Switch back</Button>
          </Alert>
        </div>
      )}
    </>
  );
};
